/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var header = $('#header');
  var originalHeaderHeight = $('#header').outerHeight();
  var originalHeaderTeaserHeight = $('#head-teaser').outerHeight();

  function isDesktop() {
    var w = $(window).width();
    return w >= 1000;
  }

  function resetHeader() {
      $('#claimContainer').css('height', '40px');
      $('#logoContainer img').css('height', '60px');
      header.css('padding-top', '25px');
      header.css('background-color', '');
      header.css('max-height', '1000px');
      header.css('height', '');
      header.css('box-shadow', '');
  }

  function updateScrollPosition() {
    if (isDesktop()) {
        var scroll = $(window).scrollTop();
        if (!$('body').hasClass('page-parent')) { // if we have no slider, we want to shrink the header immediately on scroll
            scroll += 100;
        }
        if (scroll > 100) {
            if (isDesktop()) {
                $('#claimContainer').css('height', '0px');
                $('#logoContainer img').css('height', '50px');
                header.css('padding-top', '10px');
                header.css('background-color', '#fbfbfb');
                header.css('max-height', '152px');
                //header.css('height', '152px');
                header.css('box-shadow', '0px 0px 20px 0px rgba(0,0,0,0.25)');
            }
            var headerHeight = $('#header').outerHeight();
            var headerTeaser = $('#head-teaser');

            if (isDesktop() && scroll > (originalHeaderTeaserHeight-headerHeight)) {
                headerTeaser.css('height', '142px')
                    .css('overflow', 'visibile')
                    .css('z-index', '20');
            } else {
                headerTeaser.css('height', originalHeaderTeaserHeight+'px')
                    .css('overflow', 'hidden')
                    .css('z-index', 'auto');
            }
        } else {
            resetHeader();
        }
    } else {
        resetHeader();
    }
  }
  function updateWindowSize() {
    var teaserWidth = $('#contentTeaser .contentTeaser').width();
    var teaserHeight = Math.max(teaserWidth * 0.5,240);
    $('#contentTeaser .contentTeaser').css('height', teaserHeight+'px');
    updateScrollPosition();
  }


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

      },
      finalize: function() {
        updateScrollPosition();
        updateWindowSize();

        $(window).on('scroll', updateScrollPosition);
        $(window).resize(updateWindowSize);

        $('ul.nav li,ul.nav a').unbind();
        $('ul.nav li.dropdown').hover(function() {
          if (isDesktop()) {
              $(this).find('.dropdown-menu').stop(true, true).show();
              $(this).find('[aria-haspopup="true"]').css('border-bottom', 'none');
          }
        }, function() {
          if (isDesktop()) {
            $(this).find('.dropdown-menu').stop(true, true).hide();
            $(this).find('[aria-haspopup="true"]').css('border-bottom', '');
          }
        });


        $('#mobileMenuButton').click(function(e) {
          e.preventDefault();
          var that = $(this);
          if (that.hasClass('open')) {
            $('#mainmenu .nav').css('max-height', '0px');
          } else {
            $('#mainmenu .nav').css('max-height', '1000px');
          }
          that.toggleClass('open');
        });
        $('#mainmenu .dropdown > a.nav-link').click(function(e) {
          if (!isDesktop()) {
            var that = $(this);
            if (!that.hasClass('open')) {
              e.preventDefault();
              $('#mainmenu .nav-link').removeClass('open');
              $('#mainmenu .dropdown-menu').slideUp();
              var dropdown = that.next('.dropdown-menu');
              dropdown.slideDown();
            }
            that.toggleClass('open');
          }
        });


        $('.post-widget .nav-link').click(function(e) {
           e.preventDefault();
            var widget = $(this).closest('.post-widget');
            widget.find('.nav-link').removeClass('active');
            if ($(this).hasClass('show-all')) {
              widget.find('.tab-pane').addClass('active');
            } else {
              widget.find('.tab-pane').removeClass('active');
              $( $(this).attr('href') ).addClass('active');
            }
            $(this).addClass('active');
        });

        $('#quickContact .contactButton').click(function(e) {
            var btn = $(this);
            if (btn.hasClass('open')) {
                btn.removeClass('open');
                $('#quickContact .contactContent').css('width', '0px');
            } else {
                btn.addClass('open');
                $('#quickContact .contactContent').css('width', '350px');
            }
        });

        $('#homepagePartnerSlider').slick({
              autoplay: true,
              infinite: true,
              autoplaySpeed: 5000,
              dots: false,
              arrows: false,
              fade: true
        });

        $('a.trackedDownload').click(function(e) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'trackedDownload',
                'file': $(this).attr('href')
            });
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('#homepagePartnerLinks').slick({
          centerMode: true,
          centerPadding: '32px',
          arrows: false,
          slidesToScroll: 1,
          slidesToShow: 7,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

        $('#homepageSlider').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: true,
            appendDots: '#sliderDots',
            appendArrows: '#sliderArrows',
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
